import PropTypes from 'prop-types'
import React, { Component } from 'react'
import YouTubePlayer from 'react-youtube'

class YouTube extends Component {
  componentWillReceiveProps(nextProps) {
    const { initHandler, videoId } = this.props
    if (nextProps.videoId !== this.props.videoId) {
      initHandler(videoId)
    }
  }

  componentDidMount() {
    const { initHandler, videoId } = this.props
    if (initHandler && videoId) initHandler(videoId)
  }

  componentWillUnmount() {
    const { endHandler, videoId } = this.props
    if (endHandler && videoId) endHandler(videoId)
  }

  render() {
    const {
      videoId,
      id,
      className,
      opts,
      readyHandler,
      playHandler,
      pauseHandler,
      endHandler,
      errorHandler,
      containerClassName,
    } = this.props

    const defaultOpts = {
      autoplay: true,
      color: 'white',
      hl: 'cs-cz',
      cc_lang_pref: 'cs',
      iv_load_policy: 3,
      modestbranding: 1,
      playsinline: 1,
      theme: 'light',
      suggestedQuality: 'large',
      playerVars: {
        rel: 0,
        controls: 2,
      },
    }

    const newOpts = {
      ...defaultOpts,
      ...opts,
    }
    return (
      <YouTubePlayer
        containerClassName={containerClassName}
        videoId={videoId}
        id={id}
        className={className}
        opts={newOpts}
        onReady={() => readyHandler(videoId)}
        onPlay={() => playHandler(videoId)}
        onPause={() => pauseHandler(videoId)}
        onEnd={() => endHandler(videoId)}
        onError={() => errorHandler(videoId)}
      />
    )
  }
}

YouTube.defaultProps = {
  id: null,
  className: null,
  initHandler: () => null,
  readyHandler: () => null,
  playHandler: () => null,
  pauseHandler: () => null,
  endHandler: () => null,
  errorHandler: () => null,
  containerClassName: '',
}

YouTube.propTypes = {
  videoId: PropTypes.string.isRequired,
  id: PropTypes.string,
  className: PropTypes.string,
  // disabling eslint for opts, we define default props in component
  opts: PropTypes.shape({}), // eslint-disable-line
  initHandler: PropTypes.func,
  readyHandler: PropTypes.func,
  playHandler: PropTypes.func,
  pauseHandler: PropTypes.func,
  endHandler: PropTypes.func,
  errorHandler: PropTypes.func,
  containerClassName: PropTypes.string,
}

export default YouTube
